import React from 'react';

const PasswordModal = ({
  show,
  onClose,
  reauthNeeded,
  pwError,
  pwLoading,
  currentPw,
  setCurrentPw,
  pw1,
  setPw1,
  pw2,
  setPw2,
  reauthEmail,
  setReauthEmail,
  reauthPw,
  setReauthPw,
  doPasswordChange,
  doReauth,
  sendResetEmail,
}) => {
  if (!show) return null;
  return (
    <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
      <div className="bg-white rounded shadow-lg p-6 w-full max-w-sm relative">
        <button
          className="absolute top-2 right-2 text-gray-400 hover:text-gray-600"
          onClick={onClose}
          aria-label="Close"
        >✕</button>
        <h2 className="text-lg font-bold mb-4">Change Password</h2>
        <form onSubmit={e => { e.preventDefault(); reauthNeeded ? doReauth() : doPasswordChange(); }}>
          {/* Hidden username/email field for accessibility and autofill */}
          <input
            type="email"
            name="username"
            autoComplete="username"
            value={reauthEmail || ''}
            readOnly
            tabIndex={-1}
            style={{ position: 'absolute', left: '-9999px', width: 0, height: 0, opacity: 0 }}
          />
          {!reauthNeeded ? (
            <>
              <label className="block text-sm mb-1">Current Password</label>
              <input
                type="password"
                className="w-full border p-2 rounded mb-3"
                value={currentPw}
                onChange={e => setCurrentPw(e.target.value)}
                autoFocus
                autoComplete="current-password"
              />
              <label className="block text-sm mb-1">New Password</label>
              <input
                type="password"
                className="w-full border p-2 rounded mb-3"
                value={pw1}
                onChange={e => setPw1(e.target.value)}
                autoComplete="new-password"
              />
              <label className="block text-sm mb-1">Confirm New Password</label>
              <input
                type="password"
                className="w-full border p-2 rounded mb-3"
                value={pw2}
                onChange={e => setPw2(e.target.value)}
                autoComplete="new-password"
              />
              {pwError && <div className="text-red-600 text-sm mb-2">{pwError}</div>}
              <button
                className="w-full bg-indigo-600 text-white py-2 rounded mt-2"
                type="submit"
                disabled={pwLoading}
              >
                {pwLoading ? 'Updating...' : 'Update Password'}
              </button>
            </>
          ) : (
            <>
              <div className="mb-2 text-sm text-gray-700">
                For security, please re-enter your password to continue.
              </div>
              <label className="block text-sm mb-1">Email</label>
              <input
                type="email"
                className="w-full border p-2 rounded mb-3"
                value={reauthEmail}
                onChange={e => setReauthEmail(e.target.value)}
                disabled
              />
              <label className="block text-sm mb-1">Current Password</label>
              <input
                type="password"
                className="w-full border p-2 rounded mb-3"
                value={reauthPw}
                onChange={e => setReauthPw(e.target.value)}
                autoFocus
                autoComplete="current-password"
              />
              {pwError && <div className="text-red-600 text-sm mb-2">{pwError}</div>}
              <button
                className="w-full bg-indigo-600 text-white py-2 rounded mt-2"
                type="submit"
                disabled={pwLoading}
              >
                {pwLoading ? 'Re-authenticating...' : 'Re-authenticate & Continue'}
              </button>
            </>
          )}
          <button
            className="w-full bg-gray-200 text-gray-700 py-2 rounded mt-2"
            onClick={async (e) => {
              e.preventDefault();
              if (sendResetEmail) await sendResetEmail();
            }}
            type="button"
          >
            Forgot your password? Reset via email
          </button>
        </form>
      </div>
    </div>
  );
};

export default PasswordModal;